import { render, staticRenderFns } from "./ViewAttribute.vue?vue&type=template&id=1888e46a&scoped=true"
import script from "./ViewAttribute.vue?vue&type=script&lang=js"
export * from "./ViewAttribute.vue?vue&type=script&lang=js"
import style0 from "./ViewAttribute.vue?vue&type=style&index=0&id=1888e46a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888e46a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1888e46a')) {
      api.createRecord('1888e46a', component.options)
    } else {
      api.reload('1888e46a', component.options)
    }
    module.hot.accept("./ViewAttribute.vue?vue&type=template&id=1888e46a&scoped=true", function () {
      api.rerender('1888e46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/ViewAttribute.vue"
export default component.exports